import { Model, fk, many, attr } from "redux-orm";
import { NaeSSchemaMap } from "../config/NaeSSchema";

class ArticleModel extends Model {
  static reducer(action, ArticleModel, session) {
    switch (action.type) {
      case "UPSERT_" + NaeSSchemaMap.Article.schema:
        action.payload.forEach((payload) => {
          const dbData = ArticleModel.withId(payload.id);

          const upsertData = payload;
          if (dbData) {
            const keys = Object.keys(upsertData);
            let needChange = false;
            keys.map((key) => {
              if (
                JSON.stringify(upsertData[key]) !== JSON.stringify(dbData[key])
              ) {
                needChange = true;
              }
            });

            if (!needChange) {
              return;
            }
          }

          ArticleModel.upsert(payload);
        });
        break;
    }
    // Return value is ignored.
    return session.state;
  }

  toString() {
    return this.id;
  }
  // Declare any static or instance methods you need.
}
ArticleModel.modelName = "ArticleModel";

ArticleModel.fields = {
  id: attr(),
};

export default ArticleModel;